import type { BatteryTone } from "./types";

/** Active pouring time required to go from empty to full. */
export const FILL_MS = 2500;
export const MEASURE = 0.25;
export const SETTLE_MS = 250;
export const SIP_MS = 1000;
export const ENERGIZED_MS = 650;

export function energyForCups(cupsConsumed: number): number {
  if (cupsConsumed <= 0) return 5;
  if (cupsConsumed === 1) return 38;
  if (cupsConsumed === 2) return 72;
  return 100;
}

export function reactionForCups(cupsConsumed: number): string {
  if (cupsConsumed <= 0) return "Running on empty";
  if (cupsConsumed === 1) return "Oh, that's better.";
  if (cupsConsumed === 2) return "Ideas incoming.";
  if (cupsConsumed === 3) return "Let's talk design.";
  if (cupsConsumed === 4) return "I have seventeen ideas and a prototype.";
  return "Caffeinated and designing!";
}

export function mugChargePercent(cupFill: number): number {
  const clamped = Math.min(1, Math.max(0, cupFill));
  return Math.round(clamped * 100);
}

/** Red through 20%, amber 21–60%, emerald from 61%. */
export function batteryTone(percent: number): BatteryTone {
  if (percent <= 20) return "red";
  if (percent <= 60) return "amber";
  return "emerald";
}

export function advanceFill(cupFill: number, elapsedMs: number): number {
  const step = Math.min(Math.max(elapsedMs, 0), 100);
  return Math.min(1, Math.max(0, cupFill + step / FILL_MS));
}

export function addMeasure(cupFill: number): number {
  return Math.min(1, Math.max(0, cupFill + MEASURE));
}
